import styled from "styled-components"

import Flex from "@irati/ui/src/Flex"
import ProfilePicture from "@irati/ui/src/ProfilePicture"
import {H5, Label} from "@irati/ui/src/Typography"
import React, {FC} from "react"

const StyledFlex = styled(Flex)`
  div:first-child,
  img {
    flex-shrink: 0;
  }
`
interface Props {
  firstName: string
  lastName: string
  employeeNumber: string
}

const ProfilePicAndName: FC<Props> = ({firstName, lastName, employeeNumber}) => {
  return (
    <StyledFlex gap={2}>
      <ProfilePicture small user={{firstName, lastName}} />
      <div>
        <H5>{`${firstName} ${lastName}`}</H5>
        <Label>{employeeNumber}</Label>
      </div>
    </StyledFlex>
  )
}

export default ProfilePicAndName
